export class Routing {
    static readonly login = '/login';
    static readonly resetPassword = '/resetPassword';
    static readonly setPassword = '/setPassword';
    static readonly main = '/';
    static readonly submitted = '/submitted';
    static readonly userManagement = '/userManagement';
}
